import type { IMunicipality } from '../../../../models/municipality.model';

export default class MunicipalityApiModel {
  public static mapToBusinessModel(apiModel: MunicipalityApiModel): IMunicipality {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      shortName: apiModel.shortName,
    };
  }

  public gid!: string;
  public name!: string;
  public shortName?: string;
}
